import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css'; // We'll create this for global styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './utils/sentry';
import { captureAcquisition } from './utils/acquisition';
import { installStaleBuildRecovery } from './utils/staleBuild';

// Initialize Sentry error monitoring
initSentry();

// A tab opened before a deploy reloads once onto the current build when a
// lazy page's file is gone, instead of showing the error screen.
installStaleBuildRecovery();

// Capture first-touch acquisition (utm / gclid / fbclid / referrer) as early
// as possible, before any client-side navigation can change the URL.
captureAcquisition();

// createRoot API
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
